import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  filename: string;
  wholeImport: boolean;
  busy: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteAnalysisModal({ filename, wholeImport, busy, onClose, onConfirm }: Props) {
  const { t } = useTranslation();
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const element = dialog.current;
    element?.showModal();
    return () => element?.close();
  }, []);
  return (
    <dialog ref={dialog} aria-labelledby="delete-analysis-title" aria-describedby="delete-analysis-description"
      onCancel={(event) => { event.preventDefault(); if (!busy) onClose(); }}
      className="w-full max-w-lg rounded-xl p-6 shadow-xl backdrop:bg-black/40">
      <h2 id="delete-analysis-title" className="text-lg font-semibold">{t('reconciliation.deletion.action')}</h2>
      <p className="mt-2 break-words font-medium">{filename}</p>
      <div id="delete-analysis-description" className="mt-3 space-y-2 text-sm text-gray-700">
        <p>{t(wholeImport ? 'reconciliation.deletion.wholeImport' : 'reconciliation.deletion.standalone')}</p>
        <p>{t('reconciliation.deletion.preserved')}</p>
        <p>{t('reconciliation.deletion.reupload')}</p>
      </div>
      <div className="mt-5 flex justify-end gap-3">
        <button type="button" autoFocus disabled={busy} onClick={onClose}
          className="rounded-lg border px-4 py-2 disabled:opacity-50">{t('common.cancel')}</button>
        <button type="button" disabled={busy} onClick={onConfirm}
          className="rounded-lg bg-red-600 px-4 py-2 font-medium text-white disabled:opacity-50">
          {t(busy ? 'common.loading' : 'reconciliation.deletion.action')}
        </button>
      </div>
    </dialog>
  );
}
